import { div } from "./van-tags";

const narrowColumnClassList =
	"column is-12-mobile is-7-tablet is-6-desktop is-5-widescreen is-3-fullhd";
const wideColumnClassList =
	"column is-12-mobile is-11-tablet is-11-desktop is-11-widescreen is-8-fullhd";

/**
 * @param {Object} cfg
 * @param {"narrow"|"wide"} cfg.size
 * @param  {...import("vanjs-core").ChildDom} children
 */
export function centeredColumn(cfg, ...children) {
	return div(
		{
			class: "columns is-centered is-mobile",
		},
		div(
			{
				class:
					cfg.size === "narrow"
						? narrowColumnClassList
						: wideColumnClassList,
			},
			...children,
		),
	);
}
